import { useSyncExternalStore } from 'react';

/**
 * Whether the task-inbox push channel is up.
 *
 * The inbox queries read it to decide whether they still have to poll. With the hub connected
 * every change arrives as a push and an interval is dead weight; with it down — offline, hub
 * restarting, a proxy that drops websockets — they fall back to the interval they used before
 * SignalR, so a broken socket degrades the inbox to what it was instead of freezing it.
 *
 * A module-level store rather than React context: the one subscriber (Layout) and the readers
 * (inbox queries, anywhere in the tree) share no provider, and there is only ever one connection.
 */
let connected = false;
const listeners = new Set<() => void>();

export function setTaskInboxRealtimeConnected(next: boolean): void {
  if (connected === next) return;
  connected = next;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** True while the inbox is being kept current by pushes. */
export function useTaskInboxRealtimeConnected(): boolean {
  return useSyncExternalStore(subscribe, () => connected, () => false);
}
